import React, {Fragment, useEffect} from 'react';
import {usePage} from "@inertiajs/inertia-react";
import FlashMessage from "@/Components/FlashMessage";

export default function Embedded({ children }) {
    let flash = usePage().props.flash;

    useEffect(() => {
        setTimeout(() => {
            let scrollHeight = document.querySelector("#app > div > div").scrollHeight;
            let height = scrollHeight > 100 ? scrollHeight + 20 : 485;
            window.parent.postMessage(JSON.stringify({
                "type":"resize",
                "height":height
            }), '*');
        }, 250);
    });

    return (
        <Fragment>
            <div className={'login-component embedded'}>
                {children}
            </div>
            {flash && loadFlashMessage()}
        </Fragment>
    );

    function loadFlashMessage() {
        return React.createElement(FlashMessage, {...flash})
    }
}
